export default {"src":"/_next/static/media/usdce-outline.0a647323.svg","height":41,"width":41};